module.exports = __webpack_public_path__ + "img/relocate_gateway.14933.png";